// extracted by mini-css-extract-plugin
export default {"title_container":"SubHeader_title_container__0qX8t","title":"SubHeader_title__KQEb2"};